class BaseParameter {
    constructor(libelle) {

        this.libelle = libelle;

    }
}


export default BaseParameter;